var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdoorAreas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 36 34",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#6468DE",
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    d: "M9.79217 22.6666H3.32343V11.2448h6.46874v1.5781H5.19843v3.1015h4.30468v1.5704H5.19843v3.5859h4.59374v1.5859Zm11.09843 0h-2.1328l-2.875-4.6797-2.8906 4.6797h-2.0078l3.7968-5.9218-3.539-5.5h2.0703l2.6562 4.3281 2.6407-4.3281h2.0078l-3.5547 5.5546 3.8281 5.8672Zm5.7 0h-1.8828v-9.8281H21.364v-1.5937h8.5625v1.5937h-3.3359v9.8281Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorAreas);
export default __webpack_public_path__ + "static/media/outdoor-areas.2c3e333e1e06d783b8782a35a1cd13e0.svg";
export { ForwardRef as ReactComponent };